/* Category filter (Singles / Sealed Boxes / Accessories) — show an option only while it has products.
   Shopify's collection.all_tags is capped on big collections, so the real count of each option is read from a
   count-only template (templates/collection.shopcount.liquid) and cached for 10 minutes per tab.
   The collection page swaps its filter HTML with innerHTML after every filter click (assets/monmouth-collection.js),
   and scripts inside swapped HTML never run — so this file stays loaded and re-applies itself whenever new
   [data-shop-tag] options appear (MutationObserver). */
(function () {
  'use strict';
  if (window.__mcShopFilterJs) return;
  window.__mcShopFilterJs = true;

  var TTL = 600000;
  var pending = {};

  function readCache(key) {
    try {
      var c = JSON.parse(sessionStorage.getItem('mc_shopcount_' + key) || 'null');
      if (c && Date.now() - c.t < TTL) return c.n;
    } catch (e) {}
    return null;
  }
  function writeCache(key, n) {
    try { sessionStorage.setItem('mc_shopcount_' + key, JSON.stringify({ n: n, t: Date.now() })); } catch (e) {}
  }
  function apply(els, count) {
    els.forEach(function (a) {
      var selected = a.classList.contains('mc-sidebar__option--selected');
      a.style.display = (count > 0 || selected) ? '' : 'none';
    });
  }

  function run() {
    var groups = {};
    document.querySelectorAll('[data-shop-tag]').forEach(function (a) {
      var key = a.getAttribute('data-shop-parent') + '/' + a.getAttribute('data-shop-tag');
      (groups[key] = groups[key] || []).push(a);
    });
    Object.keys(groups).forEach(function (key) {
      var els = groups[key];
      var cached = readCache(key);
      if (cached !== null) { apply(els, cached); return; }
      if (pending[key]) return;           /* a request is already running; its result is applied to the then-current elements */
      pending[key] = true;
      fetch('/collections/' + key + '?view=shopcount', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (t) {
          pending[key] = false;
          if (t === null) return;
          var n = parseInt(String(t).replace(/[^0-9]/g, ''), 10);
          if (isNaN(n)) return;
          writeCache(key, n);
          run();                          /* re-query so options created by a swap meanwhile are covered too */
        })
        .catch(function () { pending[key] = false; });
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    /* setTimeout, not requestAnimationFrame: rAF never fires in a hidden/background tab */
    setTimeout(function () { scheduled = false; run(); }, 0);
  }

  function start() {
    run();
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
